const ROOT = 'root'

export default {
    ROOT: ROOT
}
